'use client';

import { createParser, parseAsArrayOf, parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

export type QueryParams = {
  pageIndex: number;
  pageSize: number;
  q?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  tab?: string;
};

// The page index parser is zero-indexed internally,
// but one-indexed when rendered in the URL,
// to align with your UI and what users might expect.
const pageIndexParser = createParser({
  parse: (query) => {
    const page = parseAsInteger.parse(query);
    return page === null ? null : page - 1;
  },
  serialize: (value) => {
    return parseAsInteger.serialize(value + 1);
  },
});

const paginationParsers = {
  pageIndex: pageIndexParser.withDefault(0),
  pageSize: parseAsInteger.withDefault(50),
  q: parseAsString.withDefault(''),
  locations: parseAsArrayOf(parseAsString).withDefault([]),
  tab: parseAsString.withDefault('total-stock'),
  status: parseAsString.withDefault(''),
  startDate: parseAsString.withDefault(''),
  endDate: parseAsString.withDefault(''),
  sorting: parseAsString.withDefault(''),
  sortBy: parseAsString.withDefault(''),
  sortDirection: parseAsString.withDefault(''),
  minPrice: parseAsString.withDefault(''),
  maxPrice: parseAsString.withDefault(''),
  availability: parseAsArrayOf(parseAsString).withDefault([]),
  categoryId: parseAsString.withDefault(''),
  type: parseAsArrayOf(parseAsString).withDefault([]),
  keyword: parseAsString.withDefault(''),
};

const paginationUrlKeys = {
  pageIndex: 'page',
  pageSize: 'pageSize',
  q: 'q',
  availability: 'filter.availability',
  minPrice: 'filter.price.gte',
  maxPrice: 'filter.price.lte',
  sortBy: 'sortBy',
  sortDirection: 'sortDirection',
  categoryId: 'categoryId',
  type: 'filter.type',
};

export function usePaginationSearchParams() {
  return useQueryStates(paginationParsers, {
    urlKeys: paginationUrlKeys,
  });
}
